'use strict';

var _throttle = require('lodash/throttle');
var thumbsSwiper;
var mainImageSwiper;
var replacingProduct;
var doubleClickTimeout = 300;

var minicart = require('../components/minicart');
var progress = require('../components/progress');
var facilemodal = require('../components/facile-modal');
var accordion = require('../components/accordion');
var validator = require('../components/validator');
var gtmTracking = require('../components/gtmTracking');

var UiEventHelper = require('../helper/ui-event-helper');

/**
 * @function
 * @description (re)builds the tooltips via Tipper
 */
var refreshToolTips = function() {
	Tipped.hideAll();

	if ($("#promo-tip-body").length > 0) {
		Tipped.create('#promo-tip', 'promo-tip-body', {
			inline: true,
			skin: 'icebreaker-primary',
			maxWidth: 225
		});
	}

	Tipped.create('#price-prior-tip', 'price-prior-tip-body', {
		inline: true,
		skin: 'icebreaker-primary',
		maxWidth: 225
	});
};

/**
 * @function
 * @description builds the Product image and thumbnails relying on Swiper
 */
var initSwipers = function() {
	// If we're re-initalizing, clean up first
	if (thumbsSwiper) {
		thumbsSwiper.destroy();
		// manually set to null after destroying it
		// otherwise it is { destroyed: true }, which cause issues on reusing
		thumbsSwiper = null;
	}

	if (mainImageSwiper) {
		mainImageSwiper.destroy();
		mainImageSwiper = null;
	}

	// Product Thumbnails - Options and swiper init
	var productThumbnailsSelector = '#product-thumbnails > .swiper-container';
	var $ptc = $(productThumbnailsSelector);
	if ($ptc.length) {
		// move video to the 2nd thumbnail position
		if ($ptc.find('.swiper-slide').length > 2) {
			$ptc.find('.thumb-video-vimeo').insertAfter($ptc.find('.swiper-slide').get(0));
		}
		var thumbSwiperOptions = {
			spaceBetween: 10,
			slidesPerView: 6,
			loop: false,
			freeMode: true,
			freeModeSticky: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				1200: { // Matches Large breakpoint for css
					direction: 'vertical',
					slidesPerView: 10
				}
			}
		};

		thumbsSwiper = new Swiper(productThumbnailsSelector, thumbSwiperOptions);
	}

	// Product Main Images - Options and swiper init
	var productImageSelector = "#product-main-images > .swiper-container";
	var $pic = $(productImageSelector);
	if ($pic.length) {
		// move video up to the 2nd slide position
		if ($pic.find('.swiper-slide').length > 2) {
			$pic.find('.product-video-vimeo').insertAfter($pic.find('.swiper-slide').get(0));
		}
		var mainSwiperOptions = {
			spaceBetween: 10,
			preloadImages: false,
			lazy: {
				preloaderClass: 'lazy-preloader',
				loadPrevNext: true,
				loadPrevNextAmount: 1
			},
			loop: true,
			pagination: {
				type: 'bullets',
				el: '.swiper-controls .swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-controls .swiper-button-next',
				prevEl: '.swiper-controls .swiper-button-prev'
			},
			thumbs: {
				swiper: thumbsSwiper
			},
			zoom: {
				maxRatio: 2.5
			}
		};

		// If only one slide, don't want looping
		if ($pic.find('.swiper-slide').length == 1) {
			mainSwiperOptions.loop = false;
		}

		mainImageSwiper = new Swiper(productImageSelector, mainSwiperOptions);

		// mark nav buttons with 'transition' classname, which is used to decorate
		// the buttons on mobile where hover is not reliable
		var $btn = $('#product-main-images > .swiper-controls > .swiper-button');
		mainImageSwiper.on('transitionStart', function() {
			$btn.removeClass('init-state');
			$btn.addClass('transition');
		});

		// remove 'transition' class after 2s delay, to enhance buttons' existance,
		// and mitigate finger cover-up
		var _clearTimeoutID = null;
		mainImageSwiper.on('transitionEnd', function() {
			clearTimeout(_clearTimeoutID);
			_clearTimeoutID = setTimeout(function() {
				$btn.removeClass('transition');
			}, 2000);

			var activeSlideIndex = mainImageSwiper.activeIndex;
			var activeSlide = $(this.slides[activeSlideIndex]);
			var activeVideo = activeSlide.find('video');
			var modelMeasurement = $('.modelmeasurement');
			var modelMeasurementVideo = $('.modelmeasurement-video');

			if (activeVideo.length > 0) {
				// Playback Video while it is active.
				this.activeVideo = activeVideo[0];
				this.activeVideo.play();
				$(modelMeasurement).hide();
				$(modelMeasurementVideo).show();
			} else if (this.activeVideo) {
				// Pause the video when the current video becomes inactive.
				this.activeVideo.pause();
				this.activeVideo = null;
				$(modelMeasurement).show();
				$(modelMeasurementVideo).hide();
			}
		});

		// Shows the zoom tip when user just single clicks
		$pic.on('click', '.swiper-zoom-container', function () {
			$(this).siblings('.swiper-zoom-tip').stop().clearQueue().delay(100).fadeIn().delay(3000).fadeOut();
		});
	}
};

/**
 * @function
 * @description Changes product-attributes labels to have new information
 */
var variationLabels = function(container) {
	var target = (!container || $(container).length === 0) ? '#pdpMain' : container;
	var attrWrapper = $(target).find('.product-attributes .primary-attributes');
	var colorTarget = $(target).find('.product-attributes .product-color .value');
	var sizeTarget = $(target).find('.product-attributes .product-size .value');
	var selectedColor = $(target).find('.product-variations .color .swatch.selected');
	var selectedSize = $(target).find('.product-variations .size .swatch.selected');

	// Drop color swatch and label into target
	if (selectedColor.length > 0) {
		colorTarget.empty().append(selectedColor.children().attr('title'));
		attrWrapper.remove('.swatch');
		attrWrapper.prepend('<span class="swatch" style="'+selectedColor.find('span').attr('style')+'"></span>');
	} else {
		colorTarget.empty().append('--');
		attrWrapper.remove('.swatch');
	}

	// Drop size label into target
	selectedSize.length > 0 ? sizeTarget.empty().append(selectedSize.children().text()) : sizeTarget.empty().append('--');
};

/**
 * @function
 * @description Changes images in slider and zoom when new color swatch is clicked
 */
var replaceImages = function () {

	var $newImages = $("#update-images");
	var $imageContainer = $("#pdpMain .product-image-container");

	if (!($newImages.length > 0)) {
		// Bail, no update-images
		return;
	}

	// Move Images
	$imageContainer.fadeOut(250, function() {
		$imageContainer.show().html($newImages.html());
		$newImages.remove();

		// Build Swipers
		initSwipers();
	});
};

/**
 * @function
 * @description Prevent double click on switching product
 * @param {String} trigger
 * @param {Boolean} psi Product Set Item
 */
var replaceProductRunner = function (trigger, psi) {
	clearTimeout(replacingProduct);

	replacingProduct = setTimeout(function() {
		replaceProduct(trigger, psi);
	}, doubleClickTimeout);
};

/**
 * @function
 * @description Build product data on user switch
 * @param {String} trigger
 * @param {Boolean} psi Product Set Item
 */
var replaceProduct = function (trigger, psi) {
	var $this = $(trigger);
	var mpid;
	var colorSwatch;
	var position = "";
	$this.hasClass('color-swatchanchor') ? colorSwatch = true : colorSwatch = false;

	// Show Progress for PSI or if ColorSwatch
	if (psi) {
		var $psi = $this.closest(".product-set-item");
		mpid = $(".pt_productdetails .pdp").data("mpid");
		if (colorSwatch) {
			progress.show($psi);
		}
		// position of Product in Product Set List, using for GTM Product Click data
		position = $psi.find("[data-position]").data("position");
	} else if (colorSwatch) {
		progress.show('#product-main-images');
	}

	// Can't choose this, bail
	if ($this.closest(".swatch").hasClass("unselectable")) {
		return false;
	}

	// Transition out old feedback
	$this.parent().siblings(".selected").addClass("deselected").removeClass("selected");
	$this.parent().addClass("preselected");

	// Load new content
	$.ajax({
		url: $this.attr("href"),
		data: {"format": "ajax", "mpid": mpid, "psi": psi, "position": position},
		cache: false
	}).done(function(data) {
		// Replace content
		if (psi) {
			progress.hide();
			$psi.empty().html(data);
			variationLabels($psi);
		} else {
			$("#product-title").remove();
			$("#product-content-2").remove();
			$("#product-content").empty().replaceWith(data);
			// Product details accordion(s)
			accordion.attach('#product-details', '.details-trigger', '#details-content', 'closed');
			accordion.attach('#product-details', '.fabric-trigger', '#fabric-content', 'closed');
			accordion.attach('#product-details', '.sizeinfo-trigger', '#sizeinfo-content', 'closed');
			accordion.attach('#product-details', '.techinfo-trigger', '#techinfo-content', 'closed');
			variationLabels();

			// Do these only for color changes.
			if (colorSwatch) {
				replaceImages();
			}
			refreshToolTips();
			validator.init($("#product-content"));
			stickyATC(false);

			// re-init find-in-store dialog link
			window.initialiseInventoryModal && window.initialiseInventoryModal();
		}

	}).fail(function() {
		progress.hide();
	});

	if (colorSwatch) {
		var pid = $('.pt_productdetails .pdp').data('mpid');
		var color = $this.data('swatch-value');

		$.ajax({
			url: window.Urls.belowImageContent,
			data: {"format": "ajax", "pid": pid, "color": color},
			cache: false
		}).done(function(data) {
			$('#below-image-content').empty().html(data);
		});
	}

	if (typeof gaSwatchSelect == "function") {
		var _vardesc = $this.attr("title");
		gaSwatchSelect(_vardesc, $this);
	}
};

/**
 * @function
 * @description Google analytics dataLayer push on swatch click
 * @param {String} vardesc
 * @param {String} trigger
 */
var gaSwatchSelect = function(vardesc, trigger) {
	if (window.featureToggles['DX-11904']) {
		gtmTracking.pushDataLayerJson($(trigger));
	} else {
		var _productdata;
		if ($(".product-set-list").length > 0) {
			_productdata = $(trigger).closest(".product-set-item").data("selectedproduct");
		} else if ($(".product-box").length > 0) {
			_productdata = $(".product-box").data("selectedproduct");
		}
		if (_productdata) {
			dataLayer.push({
				"event": "productView",
				"ecommerce": {
					"detail": {
						"actionField": {"list": "Related Product List Name"},
						"products": [{
							"name": _productdata.name,
							"id": _productdata.id,
							"price": $(".sales-price-data").data("price"),
							"brand": "Icebreaker",
							"category": _productdata.category,
							"variant": vardesc,
							"dimension14": _productdata.gender
						}]
					}
				}
			});
		}
	}
};

/**
 * Create tracking script for cartographer, passing in JSON parameters
 * @param {String} dataString
 */
function cartographerTrackAddToCart(dataString) {
	// clean data string of any extra characters
	var cleanData = JSON.stringify(JSON.parse(dataString));

	if (!cleanData) {
		return;
	}

	// https://www.drivecommerce.com/cartographer/developer/getting-started/conversions.html#submit-add-to-cart-event
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://api.cartographer.drivecommerce.com/api/v1/runtime/addtocart?type=production&products=' + cleanData + '&time=' + (new Date().getTime());
	document.getElementsByTagName('body')[0].appendChild(script);
}

/**
 * @function
 * @description make add-to-cart sticky when scrolling down
 */
var stickyATC = function(isInit) {

	var navBarHeight = document.getElementById("navigation").offsetHeight;
	var placeholderHeight;
	var isTopSticky = false;

	function swapPosition () {
		var anchor = document.querySelector(".product-add-to-cart");
		if (!anchor) return;

		var container = anchor.querySelector(".product-atc-container");
		var placeholder = anchor.querySelector(".product-atc-placeholder");
		var anchorBottom = anchor.getBoundingClientRect().bottom;

		var mql = window.matchMedia('(min-width: 768px)');

		if (mql.matches) {
			// clean residue from mobile bottom sticky
			container.style.removeProperty('bottom');

			// sticky desktop
			if (!isTopSticky) {
				placeholderHeight = container.offsetHeight + 'px';
			}

			if (anchorBottom <= navBarHeight) {
				if (isTopSticky) {
					placeholder.style.height = placeholderHeight;
				}
				container.classList.add('wrapper-1920');
				anchor.classList.add('fix-top-atc');
				isTopSticky = true;
			} else {
				container.classList.remove('wrapper-1920');
				anchor.classList.remove('fix-top-atc');
				isTopSticky = false;
			}
		} else {
			// clean residue from desktop topright corner sticky
			container.classList.remove('wrapper-1920');
			anchor.classList.remove('fix-top-atc');
			isTopSticky = false;

			// sticky mobile
			if (anchorBottom <= window.innerHeight) {
				container.style.bottom = 0;
			}
		}
	}

	if (isInit) {
		window.addEventListener('scroll', _throttle(swapPosition, 100));
	} else {
		swapPosition();
	}
};

/**
 * @function
 * @description handling pdp hero inpirational takeover
 */
var paralaxHero = function() {
	var $pdpHeroContainer = $(".pdp-hero-container");
	var $pdpHeroParalaxLayer = $pdpHeroContainer.find(".paralax-scroll-layer");
	var $pName = $(".pdp-hero-container + .pdp .pdp-main h1.product-name");

	function pdpHeroCB() {
		var scrollDist; var scrollGap;
		var mql = window.matchMedia("(min-width: 768px)");

		if (mql.matches) {
			// desktop
			scrollDist = 200;
			scrollGap = 100;
		} else {
			// mobile
			scrollDist = 100;
			scrollGap = 60;
		}

		var scroll = $(window).scrollTop();

		// paralax scrolling on bkg and topo
		$pdpHeroParalaxLayer.each(function () {
			var layer = $(this);
			var dataSpeed = layer.data("parallax-speed");
			var offsetY = scroll * (1 - dataSpeed);
			var translate = "translateY(" + offsetY + "px)";
			layer.css({
				"-webkit-transform": translate,
				"-moz-transform": translate,
				"-ms-transform": translate,
				"-o-transform": translate,
				"transform": translate
			});
		});

		if (scroll <= scrollDist) {
			$pdpHeroContainer.addClass("pdp-hero-scrolling");
			var offsetY = scroll - scrollDist;
			var translate = "translateY(" + offsetY + "px)";
			// move product title, and hide dotted line
			$pName.css({
				"-webkit-transform": translate,
				"-moz-transform": translate,
				"-ms-transform": translate,
				"-o-transform": translate,
				"transform": translate,
				"background": "none"
			});
			// add classname for scroll position to help light color switch
			if (scroll <= scrollGap) {
				$pdpHeroContainer.addClass("pdp-hero-scroll-pos-top-mid");
			} else {
				$pdpHeroContainer.removeClass("pdp-hero-scroll-pos-top-mid");
			}
		} else {
			$pdpHeroContainer.removeClass(["pdp-hero-scrolling", "pdp-hero-scroll-pos-top-mid"]);
			translate = "translateY(0)";
			// return product title to original pos, restore dotted line
			$pName.css({
				"-webkit-transform": translate,
				"-moz-transform": translate,
				"-ms-transform": translate,
				"-o-transform": translate,
				"transform": translate,
				"background": ""
			});
		}
	}

	if ($pdpHeroContainer.length > 0) {
		pdpHeroCB(); // initial run
		window.addEventListener('scroll', _throttle(pdpHeroCB, 3));
	}
};

/**
 * @function
 * @description initialize size-guide table in modal dialog
 * @param {String} modal_ID
 */
// eslint-disable-next-line camelcase
var initSizeChartCallback = function(modal_ID) {
	var $sizeChart = $(modal_ID.replace("#", ".") + "-box .chart.with-tabs");
	var _selectedId = $("ul", $sizeChart).children(".default").index();

	$sizeChart.tabs({
		active: _selectedId
	});
};

var initTabbedRecommenders = function() {
	$('.tabbed-recommenders').tabs();
};

/**
 * Send product data on PDP to Scarab JS Library on initial load
 */
function triggerScarabPush() {
	try {
		let selectedSize = null;
		const sizeSwatch = document.getElementById('sizeSwatch');
		if (sizeSwatch && sizeSwatch.classList.contains('selected')) {
			const swatch = sizeSwatch.querySelector('a');

			if (swatch) {
				const productInfo = JSON.parse(swatch.dataset.productInfo);
				if (productInfo && productInfo.size) {
					selectedSize = productInfo.size;
				}
			}
		}
		// ScarabQueue is a variable declared in htmlhead
		if (ScarabQueue) {
			const scarabElement = document.getElementById('scarabData');
			// Retrieve the data-scarabdata attribute
			const scarabData = JSON.parse(scarabElement.getAttribute('data-scarabdata'));
			// Note: data-scarabdata can be null.
			if (scarabData) {
				if (selectedSize) {
					// when a size is selected, push the variant ID
					ScarabQueue.push(["view", scarabData.selectedColourIdWithoutPrefix + selectedSize]);
				} else if (scarabData.selectedColour) {
					// when just the colour is selected, push the selected colour group ID
					ScarabQueue.push(["view", scarabData.selectedColour]);
				} else {
					// send the default colour group ID
					ScarabQueue.push(["view", scarabData.defaultColourGroupId]);
				}
				// go is the submission command
				ScarabQueue.push(['go']);
			}
		}
	} catch (e) {
		// catching to let other functions work as usual incase of an error
	}
}

/**
 * @function
 * @description All events
 */
var initializeEvents = function() {
	var $pdpMain = $("#pdpMain");

	// Select Product variations
	$pdpMain.on("click", "#product-content a.swatchanchor", function (e) {
		e.preventDefault();
		try {
			// send selected item info to Scarab Library
			const productInfo = JSON.parse(this.dataset.productInfo);
			const size = productInfo.size && productInfo.size.length > 0 ? productInfo.size : '';
			const productId = productInfo.masterID + productInfo.colour + size;
			if (ScarabQueue) {
				ScarabQueue.push(["view", size.length < 1 ? 'g/' + productId : productId]);
				ScarabQueue.push(['go']);
			}
		} catch (e) {
			// catching to let other functions work as usual incase of an error
		}
		replaceProductRunner(this, false);
	});

	// Select Product variations -- Product Set
	$pdpMain.on("click", ".product-set-list a.swatchanchor", function (e) {
		e.preventDefault();
		replaceProductRunner(this, true);
	});

	// prevent double click on swatches
	$pdpMain.on("dblclick", "#product-content a.swatchanchor, .product-set-list a.swatchanchor", function (e) {
		e.preventDefault();
	});

	$pdpMain.add(".product-modelfit").on("click", ".size-guide", function(e) {
		e.preventDefault();

		e.stopPropagation();

		var elm = e.currentTarget;
		if (elm) {
			var modalId = elm.getAttribute("href");
			var modalW = elm.dataset['modalWidth'];
			var modalWp = elm.dataset['modalWidthPercent'];
			var modalH = elm.dataset['modalHeight'];
			var _url = elm.dataset["href"];

			var CB = {
				call: function() {
					initSizeChartCallback(modalId);
				}
			};

			facilemodal.showModal(modalId, _url, modalW, modalWp, modalH, null, null, CB);
		}

	});

	// Add-to-cart
	var highlightTimeout = null;
	$pdpMain.on("click", "button#add-to-cart", function(e) {
		e.preventDefault();

		var _pid;
		// ID of the product currently viewed on the PDP.
		var _merchandisedProductId;
		var $this = $(this);

		if ($this.hasClass("add-to-cart-disabled")) {
			var sizeSelector = $this.closest('.product-content').find('.product-variations .swatches.size');
			var bounding = sizeSelector.get(0).getBoundingClientRect();
			var navBarHeight = $('#navigation').height();
			var atcContainerHeight = $('.product-atc-container').height();

			if (
				// too close to the top navbar or bottom atc container
				(bounding.top + bounding.height / 4 < navBarHeight ||
					bounding.bottom - bounding.height / 4 > (window.innerHeight || document.documentElement.clientHeight) - atcContainerHeight)
			) {
				$('html, body').animate({
					scrollTop: sizeSelector.offset().top - window.innerHeight / 2
				}, 250, function() {
					window.setTimeout(function() {
						sizeSelector.addClass('highlight');
					}, 250);
				});
			} else {
				sizeSelector.addClass('highlight');
			}

			if (highlightTimeout) {
				clearTimeout(highlightTimeout);
			}

			highlightTimeout = setTimeout(function() {
				sizeSelector.removeClass('highlight');
			}, 2000);

			return false;
		}

		if ($(".product-set-list").length > 0) {
			_pid = $this.closest(".product-set-item").find("input[name$='pid']").val();
			_merchandisedProductId = $this.closest(".product-set-item").find("input[name$='merchandisedProductId']").val();
		} else if ($(".product-box").length > 0) {
			_pid = $("#pid").val();
			_merchandisedProductId = $("#merchandisedProductId").val();
		}

		if (_pid.length > 0) {
			// track cartographer analytics
			var $cartographer = $this.parents('.product-add-to-cart').find('.cartographer-product-data');
			if ($cartographer.length > 0) {
				cartographerTrackAddToCart($cartographer.text());
			}

			facilemodal.closeFmModal(); // close modal dialog

			minicart.add( "", {"pid": _pid, "Quantity": 1, "merchandisedProductId": _merchandisedProductId}, function() {
				gtmTracking.pushCartAction($this);
				UiEventHelper.openCart(true); // open cart ui after add-to-cart
			});
		}
	});

	initTabbedRecommenders();
};

/**
 * @function
 * @description DOM initialization
 */
var initializeDOM = function() {

	// Build image swiper(s)
	initSwipers();

	refreshToolTips();

	// Product details accordion(s)
	accordion.attach('#product-details', '.details-trigger', '#details-content', 'closed');
	accordion.attach('#product-details', '.fabric-trigger', '#fabric-content', 'closed');
	accordion.attach('#product-details', '.sizeinfo-trigger', '#sizeinfo-content', 'closed');
	accordion.attach('#product-details', '.techinfo-trigger', '#techinfo-content', 'closed');

	// Update color selected labels
	// if product set, loop each
	if ($(".product-set-list").length > 0) {
		$(".product-set-item").each(function() {
			variationLabels(this);
		});
	} else {
		variationLabels();
		// handle inspirational takeover hero
		paralaxHero();
		// make add-to-cart container sticky to the header
		stickyATC(true);
	}

	// send product info to Scarab Library on page load
	triggerScarabPush();
};

const pageEntry = {
	init: function () {
		initializeDOM();
		initializeEvents();
	}
};

if (!window.appPages) {
	window.appPages = {};
}

window.appPages.product = pageEntry;
